import Header from "../components/Home/Header";
import JobList from "../components/Home/JobList";
import Layout from "../components/Layout";

export default function HomePage() {
  return (
    <Layout>
      <Header/>
      <JobList/>
    </Layout>
  )
}